
namespace GeniuzPOS.AdvPromo {

    @Serenity.Decorators.registerClass()
    export class PsAdvPromoTypeDialog extends Serenity.EntityDialog<PsAdvPromoTypeRow, any> {
        protected getFormKey() { return PsAdvPromoTypeForm.formKey; }
        protected getIdProperty() { return PsAdvPromoTypeRow.idProperty; }
        protected getLocalTextPrefix() { return PsAdvPromoTypeRow.localTextPrefix; }
        protected getNameProperty() { return PsAdvPromoTypeRow.nameProperty; }
        protected getService() { return PsAdvPromoTypeService.baseUrl; }
        protected getDeletePermission() { return PsAdvPromoTypeRow.deletePermission; }
        protected getInsertPermission() { return PsAdvPromoTypeRow.insertPermission; }
        protected getUpdatePermission() { return PsAdvPromoTypeRow.updatePermission; }

        protected form = new PsAdvPromoTypeForm(this.idPrefix);

    }
}